import React from 'react';

const TablaStudentRegisterExcel = ({students}) =>{

  return(
    <div>
      <h4 className="text-lg font-semibold mb-4">Alumnos Registrados</h4>
      <div className="overflow-x-auto">
        <table className="min-w-full border text-xs">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-2 px-4 border text-left">Nombre</th>
              <th className="py-2 px-4 border text-left">CURP</th>
              <th className="py-2 px-4 border text-left">Email</th>
              <th className="py-2 px-4 border text-left">Carrera</th>
              <th className="py-2 px-4 border text-left">Modalidad</th>
            </tr>
          </thead>
          <tbody>
            {students?.map(student => (
              <tr key={student.id}>
                <td className="py-2 px-4 border">{student.name}</td>
                <td className="py-2 px-4 border">{student.curp}</td>
                <td className="py-2 px-4 border">{student.email}</td>
                <td className="py-2 px-4 border">{student.career}</td>
                <td className="py-2 px-4 border">{student.mode}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TablaStudentRegisterExcel